module.exports = __webpack_public_path__ + "img/customer-a-071.2eb70999.png";